var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertSlide5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15 17h-14v-16h11.143c.093-.356.234-.69.415-1h-12.558v21.5c0 1.379 1.122 2.5 2.5 2.5h11c1.378 0 2.5-1.121 2.5-2.5v-8.5h-1zm0 4.5c0 .827-.673 1.5-1.5 1.5h-11c-.827 0-1.5-.673-1.5-1.5v-3.5h14zm-5-.5h-4v-1h4zm12-21-6 .002c-1.103 0-2 .899-2 2.001v7.858c.001.438.246.831.639 1.024.162.08.334.119.506.119.246 0 .49-.08.694-.237l2.302-1.768h5.858v-6.999c0-1.103-.897-2-2-2zm1 8h-5.198l-2.572 1.975c-.107.07-.229.025-.229-.113v-7.859c-.001-.552.447-1 .999-1.001l6-.002c.551 0 1 .448 1 1zm-15 1c1.378 0 2.5-1.121 2.5-2.5s-1.122-2.5-2.5-2.5-2.5 1.121-2.5 2.5 1.122 2.5 2.5 2.5zm0-4c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5zm3 9v-2c0-.552-.449-1-1-1h-4c-.551 0-1 .448-1 1v2h-1v-2c0-1.103.897-2 2-2h4c1.103 0 2 .897 2 2v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertSlide5);
export default __webpack_public_path__ + "static/media/expert-slide-5.cd276bbea4601b30a815e8828337345e.svg";
export { ForwardRef as ReactComponent };